import { validateField } from "@/utils/location"
import { validatePhone } from "@/js/helperV2"

const getShippingEventInfo = (type, needJSON = false) => {
  const eventInfo = {
    eventAction: `checkout:shipping:${type}`,
    eventName: `checkout:shipping:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const isBackOrder = (shipItems = []) => {
  const arr = []
  shipItems.forEach(item => {
    const isTrue =
      item?.backOrder && item.leadTime && item.quantity > item.availableQty
    arr.push(isTrue)
  })
  return arr.includes(true)
}

export const validateInput = async (field, val = "", data, i18n) => {
  const value = val?.trim()

  switch (field) {
    case "fname":
    case "lname":
      if (!value) {
        return field === "fname" ? i18n.fnameError : i18n.lnameError
      } else if (!(await validateField("name", value))) {
        return i18n.nameValidation
      }
      break
    case "email":
      if (!data.email.value) return i18n.noEmailError
      else if (!(await validateField("email", value))) return i18n.validEmail
      break
    case "phone":
      if (!value || !validatePhone(value)) return i18n.validPhone
      break
    case "address1":
      if (!value) return i18n.addressError
      else if (!(await validateField("address", value)))
        return i18n.nameValidation
      break
    case "city":
      if (!value) return i18n.cityError
      else if (!(await validateField("city", value))) return i18n.cityValidation
      break
    case "state":
      if (!value) return i18n.stateError
      break
    case "zipcode":
      if (!value) return i18n.zipcodeError
      else if (
        value.length < 5 ||
        !(await validateField("zipCodeNumeric", value))
      )
        return i18n.validZipcode
      break

    case "companyName":
      if (!value) return i18n.companyNameError
      else if (!(await validateField("businessName", value)))
        return i18n.nameValidation
      break

    case "label":
      if (
        value.length > 0 &&
        !(await validateField("saveAddressLabel", value))
      ) {
        return i18n.nameValidation
      }
      break
    default:
      return
  }
}

export { getShippingEventInfo }
